import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import { ProfileImageComponent } from 'src/app/components/profile-image/profile-image.component';
import * as myGlobals from 'src/app/globals';
import { UserProfileModel } from 'src/app/models/profile.model';
import { CasePipe } from 'src/app/pipes/case.pipe';
import { AuthStore } from 'src/app/services/auth.store';
import { CommonService } from 'src/app/services/common.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PathService } from 'src/app/services/path.service';
import { UploadService } from 'src/app/services/upload.service';
@Component({
  selector: 'app-top-right-dropdown',
  templateUrl: './top-right-dropdown.component.html',
  styleUrls: ['./top-right-dropdown.component.scss'],
  standalone: true,
  providers: [PathService],
  imports: [ProfileImageComponent, RouterModule, TranslateModule, CasePipe, CommonModule, TranslateModule],
})
export class TopRightDropdownComponent implements OnInit, OnDestroy {
  @Input() public secure: boolean | null = null;
  @Input() public hidden: boolean | null = null;
  @Input() public profileSettingLink: string | null = null;
  @Input() public secureSettingLink: string | null = null;
  @Input() public securitySettingsLink: string | null = null;
  @Input() public helpLink: string | null = null;
  @Output() newButtonClick = new EventEmitter<void>();
  @Output() exitClick = new EventEmitter<void>();
  @Output() docxClick = new EventEmitter<void>();
  @Output() pptClick = new EventEmitter<void>();
  @Output() xlsxClick = new EventEmitter<void>();
  @Output() createFolder = new EventEmitter<string>();
  @Output() templateDocumentClick = new EventEmitter<void>();

  @ViewChild('newButton') newButton!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('folderInput') folderInput!: ElementRef;
  subscription: Subscription = new Subscription();
  permission = localStorage.getItem('permission') === 'EDIT' ? 'EDIT' : 'VIEW';

  showNewButton = true;
  showButton = true;
  isSafelockActivated = false;
  isSafelockEnabled!: boolean;
  isAuthenticated = false;
  securedFolder = false;

  backgroundColor!: string;
  objectId?: string;
  userData!: UserProfileModel;

  constructor(
    public authStore: AuthStore,
    public commonService: CommonService,
    public pathService: PathService,
    private notificationService: NotificationService,
    private router: Router,
    private uploadService: UploadService,
  ) {
    this.subscription.add(
      this.commonService.objectId$.subscribe((data) => {
        this.objectId = data;
      }),
    );
    this.subscription.add(
      this.authStore.userProfile$.subscribe((data) => {
        this.userData = data;
        if (myGlobals.Config.hasRtukUrl) {
          this.userData.firstName = this.commonService.removeLastWord(this.userData.firstName);
        }
      }),
    );
    this.subscription.add(
      commonService.securedFolder$.subscribe((data) => {
        this.securedFolder = data;
      }),
    );
  }

  ngOnInit(): void {
    this.showNewButton = this.pathService.canCreateFolderHere();
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.showNewButton = this.pathService.canCreateFolderHere();
      if (this.showNewButton) {
        this.newButton.nativeElement.classList.remove('disabled');
        this.newButton.nativeElement.classList.remove('disabledButton');
      } else {
        this.subscription.add(
          this.commonService.showNewButton.subscribe((value) => {
            if (value) {
              this.permission = 'EDIT';
              this.showNewButton = true;
              this.newButton.nativeElement.removeAttribute('disabled');
              this.newButton.nativeElement.classList.remove('disabledButton');
            } else if (!this.showNewButton) {
              this.showNewButton = false;
              this.permission = 'VIEW';
              this.newButton.nativeElement.classList.add('disabled');
              this.newButton.nativeElement.classList.add('disabledButton');
            }
          }),
        );
      }
    });

    this.subscription.add(
      this.authStore.isSafeLockEnabled$.subscribe((value) => {
        this.isSafelockEnabled = !!value;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  openCreateFolderModal(modalId: string): void {
    this.createFolder.emit(modalId);
  }

  onNewButtonClick(): void {
    this.newButtonClick.emit();
  }

  onExitClick(): void {
    this.exitClick.emit();
  }

  onFilesSelected(files: FileList | null): void {
    if (this.objectId || this.router.url.startsWith('/depom') || this.router.url.startsWith('/paylasimlar')) {
      if (files) {
        this.uploadService.uploadFile(files);
      }
    } else {
      const message = {
        message: this.commonService.getTranslatedMessage('CANNOT_UPLOAD_TO_HOME_DIRECTORY'),
      };
      this.notificationService.errorNotification(message);
    }
    this.fileInput.nativeElement.value = '';
  }

  onFoldersSelected(files: FileList | null): void {
    if (files) {
      this.uploadService.uploadFolder(files);
    }
    this.folderInput.nativeElement.value = '';
  }

  onFolderUploadClick(): void {
    this.folderInput.nativeElement.click();
  }

  OnDocxClick(): void {
    this.docxClick.emit();
  }

  OnPptClick(): void {
    this.pptClick.emit();
  }

  OnXlsxClick(): void {
    this.xlsxClick.emit();
  }

  OnTemplateDocumentClick(): void {
    this.templateDocumentClick.emit();
  }
}
